import React from "react";
import { useNavigate } from "react-router-dom";

const TPshop = ({ shop }) => {
  const navigate = useNavigate();

  // Rating
  const rating = Number(shop.tpshoprating_avg_rating || 0);

  return (
    <div
      className="shop-card"
      onClick={() => navigate(`/shop/${shop.id}`)}
    >
      <div className="shop-top">

        <div className="shop-avatar">
          {shop.shopname?.charAt(0)}
        </div>

        <div className="shop-info">
          <div className="shop-name-row">

            <span className="shop-name">
              {shop.shopname}
            </span>

            {shop.verified && (
              <svg
                className="verified-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#22c55e"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
            )}

          </div>

          <span className="shop-category">
            {shop.businessCategory}
          </span>
        </div>
      </div>

      {/* RATING */}
      <div className="shop-meta">
        ⭐ {rating.toFixed(1)}/5

        <span>
          ({shop.tpshoprating_count || 0} Reviews)
        </span>
      </div>

     

      <span className="shop-deals">
        {shop.tpdeal_count || 0} Deals
      </span>

      <span className="shop-city">
        {shop.businessAddress}
      </span>

    </div>
  );
};

export default TPshop;